const uiSchema = () => ({
  details: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
